import { render, staticRenderFns } from "./PaginationCom.vue?vue&type=template&id=b6307ac4&"
import script from "./PaginationCom.vue?vue&type=script&lang=js&"
export * from "./PaginationCom.vue?vue&type=script&lang=js&"
import style0 from "./PaginationCom.vue?vue&type=style&index=0&id=b6307ac4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports